import styled from 'styled-components'
import measures from 'globals/measures'
import colors from 'globals/colors'

export const SelectedMailsButtonsWrapper = styled.div`
  display: flex;

  & > span {
    display: none;
  }

  & > button.ant-btn {
    margin-right: 16px;
  }

  @media(max-width: ${measures.mobileThreshold}px) {
    line-height: 40px;
    padding: 8px 0;
    align-items: center;
    justify-content: space-evenly;

    & > button.ant-btn {
      font-size: 14px;
      margin-right: 0px;
      margin-left: 16px;

      &:focus, &:active {
        background: ${colors.waterBlue};
      }
    }

    & > span {
      height: 40px;
      width: 1px;
      background: white;
      display: block;
    }

    & > a {
      padding: 0;
      margin: 0;
      color: white;
      text-decoration: none;
    }
  }
`
